import { Component, OnInit } from '@angular/core';
import { MatDatepickerInputEvent, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SapRoles } from 'src/_constants/roleType';
import { AppService } from 'src/_services/app.service';

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit{

  showAlert: any = false;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  sapRoles = SapRoles;
  events = [];
  usersData = [];
  userCount = [];
  betsData = [];
  betAmount = [];
  opBetsData = [];
  prBetsData = [];
  opAmount = [];
  prAmount = [];
  lastSevenDays = [];
  marketReport = [];
  selectedTab = "";
  selectedBetTab = "";
  selectedPRBetTab = "";
  selectedOPAmt = "";
  selectedPRAmt = "";
  alertscount = 0;
  dropdownSettings: any = {};
  selected: any = {
    startDate: moment().startOf("day"),
    endDate: moment().endOf("day"),
  };

  sportsMap: Map<string, string> = new Map([
    ['4', 'cricket'],
    ['1', 'soccer'],
    ['2', 'tennis']
  ]);
  reqSports = Array.from(this.sportsMap.keys());

  gameImagesMap: Map<string, string> = new Map([
    ['4', '../../../assets/images/cricket.svg'],
    ['1', '../../../assets/images/football.svg'],
    ['2', '../../../assets/images/tennis.svg']
  ]);

  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };

constructor(
  private appService: AppService,
  public dialog: MatDialog,
  private router: Router
) {}

ngOnInit() {
  this.getUnmappedEvents(this.reqSports);
  this.getAlertBetsCount();
  this.getUsersCount();
  this.getPastDays(moment().format("YYYY-MM-DD"), 7)
  this.getBetsCount();
  this.getBetsAmount();
  this.getMarketReport();
}

onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
  this.selected = event;

  if (this.selected.endDate) {
    let start = this.selected.startDate;
    let end = this.selected.endDate;
    let diff = end.diff(start, "days") + 1;
    if (diff > 7) {
      this.showAlert = true;
      this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
      this.selected.endDate = moment(new Date().setHours(23, 59, 59));
      setTimeout(() => {
        this.showAlert = false;
      }, 3000);
    }
  }
};

getUnmappedEvents(value) {
  try {
    let filters = {
      sports : value,
      startTime:
        this.selected.startDate !== null
          ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };

    this.appService.getUnmappedEventsCount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        if (value.length <= 1 && res.events.length > 0) {
          const index = this.events.findIndex(event => event.sportId === value[0]);
          if (index !== -1) {
            this.events[index].mapped = res.events[0].mapped;
            this.events[index].unmapped = res.events[0].unmapped;
          }
        } else {
          this.events = res.events.sort((a, b) => {
            return this.sportsMap.get(a.sportId).localeCompare(this.sportsMap.get(b.sportId));
        });
        }
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getUsersCount() {
  try {
    let filters = {
      startTime: moment().format("YYYY-MM-DD"),
    };
    this.appService.getUsersCount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.userCount = res.userList
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getOperatorUsersCount() {
  try {
    let filters = {
      startTime: this.selectedTab,
    };
    this.appService.getOPUsersCount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.usersData = res.opList;
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getBetsCount() {
  try {
    let filters = {
      startTime: moment().format("YYYY-MM-DD"),
    };
    this.appService.getBetsCount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.betsData = res.betList
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getBetsAmount() {
  try {
    let filters = {
      startTime: moment().format("YYYY-MM-DD"),
    };
    this.appService.getBetsAmount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.betAmount = res.amountList
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getOperatorBetsCount() {
  try {
    let filters = {
      startTime: this.selectedBetTab,
    };
    this.appService.getOPBetsCount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.opBetsData = res.opList
            .map((op) => ({
                ...op,
                accepted: op.accepted ? parseInt(op.accepted) : 0
            })).sort((a, b) => b.accepted - a.accepted);
        
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getProviderBetsCount() {
  try {
    let filters = {
      startTime: this.selectedPRBetTab,
    };
    this.appService.getPRBetsCount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.prBetsData = res.prList;
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getOperatorBetAmount() {
  try {
    let filters = {
      startTime: this.selectedOPAmt,
    };
    this.appService.getOPBetAmount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.opAmount = res.opAmt;
        
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getProviderBetAmount() {
  try {
    let filters = {
      startTime: this.selectedPRAmt,
    };
    this.appService.getPRBetAmount(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.prAmount = res.prAmt;
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getAlertBetsCount() {
  try {
    this.appService.getAlertBetsCount().subscribe((res) => {
      if (res.status === "RS_OK") {
        this.alertscount = res.count;
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

getMarketReport() {
  try {
    let filters = {
      startTime:
        this.selected.startDate !== null
          ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
      endTime:
        this.selected.endDate !== null
          ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
    };
    this.appService.getmarketReport(filters).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.marketReport = res.marketReport;
      } else {
        if (res.errorDescription === "Invalid Token!") {
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        }
        this.appService.openErrorBar(res.errorDescription)
      }
    });
  } catch(err) {}
}

onTabChange(index) {
  this.selectedTab = this.lastSevenDays[index]
  this.getOperatorUsersCount();
}

onBetTabChange(index) {
  this.selectedBetTab = this.lastSevenDays[index]
  this.getOperatorBetsCount();
}

onPRBetTabChange(index) {
  this.selectedPRBetTab = this.lastSevenDays[index]
  this.getProviderBetsCount();
}

onOPAmtTabChange(index) {
  this.selectedOPAmt = this.lastSevenDays[index]
  this.getOperatorBetAmount();
}

onPRAmtTabChange(index) {
  this.selectedPRAmt = this.lastSevenDays[index]
  this.getProviderBetAmount();
}

getPastDays(startDateStr, days) {
  const startDate = new Date(startDateStr);
  const pastDays: string[] = [];

  for (let i = 0; i < days; i++)  {
      const date = new Date(startDate);
      date.setDate(startDate.getDate() - i);
      pastDays.push(date.toISOString().split('T')[0]);
  }
  this.selectedTab = pastDays[0];
  this.selectedBetTab = pastDays[0];
  this.selectedPRBetTab = pastDays[0];
  this.selectedOPAmt = pastDays[0];
  this.selectedPRAmt = pastDays[0];
  this.lastSevenDays = pastDays;
  this.getOperatorUsersCount();
  this.getOperatorBetsCount();
  this.getProviderBetsCount();
  this.getOperatorBetAmount();
  this.getProviderBetAmount();
}

transformDate(dateString) {
  const date = moment(dateString, 'YYYY-MM-DD');
  return date.format('Do MMM');
}

onSubmit() {
  this.getUnmappedEvents(this.reqSports);
  this.getAlertBetsCount();
  this.getUsersCount();
  this.getOperatorUsersCount();
  this.getBetsCount();
  this.getOperatorBetsCount();
  this.getProviderBetsCount();
  this.getBetsAmount();
  this.getOperatorBetAmount();
  this.getProviderBetAmount();
  this.getMarketReport();
}

goToMapping(sportId) {
  this.router.navigate(["administration/mapping"], {
    queryParams: {
      sportId: sportId,
      startDate: this.selected.startDate,
      endDate: this.selected.endDate,
    },
  });
}

goToRiskBets() {
  this.router.navigate(["surveillance/risk_bets"], {
    // queryParams: {},
  });
}

}
